module.exports = __webpack_public_path__ + "static/img/help.5c6e3fb6.svg";